import {
  convertDateToReadableText,
  exportFileSendMail,
} from 'src/app/forms/ExportInterestForm/export-interest-form.config';
import { pdfExport } from 'src/app/helpers/pdf.helper';
import { NSearchLoggerType } from 'src/app/redux/nSearch/nSearch-slice-type';
import { getNSearchLogs } from 'src/app/services/nSearchBackend/nSearchLogger-service';
import { ReportTypes } from 'src/enums/logger-export.enum';
import tinycolor from 'tinycolor2';

const reportTypeEnumsObj = {
  company_info: ReportTypes.Company_Info,
  customer_info: ReportTypes.Customer_Info,
  subscription: ReportTypes.Subscription,
  user_activity: ReportTypes.User_Activity,
  resource: ReportTypes.Resource,
  nsearch: ReportTypes.Nsearch,
};

export const sysLogsOptions = (reportTypes: string[]): { key: string; value: ReportTypes; label: string }[] => {
  const filteredType = reportTypes.map((reportType: string) => {
    const key = reportType.toLowerCase() as keyof typeof reportTypeEnumsObj;
    return {
      key: reportType,
      value: reportTypeEnumsObj[key],
      label: reportType
        .split('_')
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(), // First letter uppercase, rest lowercase
        )
        .join(' '),
    };
  });

  return filteredType;
};

export const getNSearches = async ({
  mailList,
  customerIds,
  excel,
  isSendAttachment,
  headerColor,
  startDate,
  endDate,
}: {
  mailList: string[];
  customerIds?: string[];
  excel?: any;
  isSendAttachment?: boolean;
  headerColor: string;
  startDate?: number;
  endDate?: number;
}) => {
  try {
    const { data } = await getNSearchLogs({
      ...(customerIds && { customerIds }),
      ...(startDate && { startDate }),
      ...(endDate && { endDate }),
      actions: ['nsearch'],
    });
    const fixedRows = data.rows.map((row) => ({ ...row.details, createdAt: row.createdAt, username: row.actor }));
    const pdfData = await exportNSearchPdf({ nSearch: fixedRows, mailList, excel, isSendAttachment, headerColor });
    return pdfData;
  } catch (error) {
    console.log('error', error);
  }
};

const allInterestTableValues = (nSearch: NSearchLoggerType[]) => {
  const headers = [
    'User',
    'Source Category',
    'Source Type',
    'Source',
    'Interests',
    'Media Type',
    // "Location",
    'Action Date',
  ];

  const values = nSearch.map((logData) => [
    { field: logData.username, cellWidth: 'auto' },
    { field: logData.dataSourceCategory?.join('\n'), cellWidth: 'auto' },
    { field: logData.dataSourceType?.join('\n'), cellWidth: 'auto' },
    { field: logData.dataSource?.join('\n'), cellWidth: 'auto' },
    { field: logData.interests?.join('\n'), cellWidth: 'auto' },
    { field: logData.mediaTypes?.join('\n'), cellWidth: 'auto' },
    // logData.coordinates?.map(coordinate => [coordinate.lat.toFixed(6), coordinate.lng.toFixed(6)].join(", ")).join("\n"),
    { field: convertDateToReadableText(logData.createdAt), cellWidth: 'auto' },
  ]);

  return { values, headers };
};

export const exportNSearchPdf = async ({
  nSearch,
  mailList,
  excel,
  isSendAttachment,
  headerColor,
}: {
  nSearch: NSearchLoggerType[];
  mailList: any[];
  excel?: any;
  isSendAttachment?: boolean;
  headerColor: string;
}) => {
  const tableDataValues = allInterestTableValues(nSearch);
  const pdfData = pdfExport({
    headers: tableDataValues.headers,
    tableBodyValues: tableDataValues.values,
    // interestName: 'NSearch',
    options: {
      orientation: 'p',
      format: 'a4',
    },

    headStyles: {
      fontSize: 8,
      fillColor: headerColor,
      textColor: tinycolor(headerColor).isDark() ? '#fff' : '#000',
    },
    // isReturnFunc: true,
  });
  if (mailList?.length > 0) {
    if (excel) {
      exportFileSendMail({
        emails: mailList,
        type: 'pdf & excel',
        ...(isSendAttachment && { excel, pdf: pdfData }),
      });
    } else {
      exportFileSendMail({ emails: mailList, type: 'pdf', pdf: pdfData });
    }
  }
  return pdfData;
};
